import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const PromoPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Show popup after 2 seconds
    const timer = setTimeout(() => {
      const hasSeenPromo = sessionStorage.getItem('promoSeen');
      if (!hasSeenPromo) {
        setIsOpen(true);
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    sessionStorage.setItem('promoSeen', 'true');
  };

  const handleWhatsApp = () => {
    const message = "Hola, me interesa el 7% de descuento por rentar 6 días o más";
    const url = `https://wa.me/18099640099?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
    handleClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 animate-fadeIn">
      <div className="relative bg-zinc-900 border-2 border-yellow-700 max-w-md w-full p-8 shadow-2xl">
        {/* Close Button */}
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-white/70 hover:text-white transition-colors"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Content */}
        <div className="text-center">
          <div className="inline-block bg-yellow-700 text-white px-4 py-2 mb-6 font-bold text-sm">
            🎉 OFERTA ESPECIAL
          </div>
          
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
            7% de Descuento
          </h3>
          
          <p className="text-xl text-white/90 mb-8">
            Aprovecha un <span className="text-yellow-600 font-bold">7% de descuento</span> en nuestras unidades al rentar por <span className="text-yellow-600 font-bold">6 días o más</span>
          </p>

          <button
            onClick={handleWhatsApp}
            className="w-full bg-yellow-700 text-white py-4 px-6 font-bold text-lg hover:bg-yellow-800 transition-all duration-300 mb-4"
          >
            ¡Quiero Mi Descuento!
          </button>

          <button
            onClick={handleClose}
            className="text-white/60 hover:text-white text-sm transition-colors"
          >
            Continuar sin descuento
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromoPopup;
